import service from '@/store/services/articles/article-categories-service';

const state = {
    list: [],
    category: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, category) => {
        state.category = category;
    },
};

const actions = {
    list({ commit, dispatch }) {
        return service.list()
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((category) => { commit('SET_RESOURCE', category); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((category) => { commit('SET_RESOURCE', category); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((category) => { commit('SET_RESOURCE', category); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    all: state => state.list.map(t => ({
        id: t.id,
        value: t.name,
        slug: t.slug
    })),
    getCategoryByName: state => (name) => {
        return state.list.find(t => t.name === name)
    },
    category: state => state.category,
};

const article_categories = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default article_categories;